import { StyleSheet } from 'react-native';

export default StyleSheet.create({
  touchableArea: {
    height: 48,
    position: 'relative',
  },
  container: theme => ({
    backgroundColor: theme.colors.cardBackgroundColor,
    borderTopRightRadius: 5,
    borderTopLeftRadius: 5,
    borderBottomRightRadius: 5,
    borderBottomLeftRadius: 5,
    flex: 1,
    flexDirection: 'row',
    paddingHorizontal: 8,
    alignItems: 'center',
  }),
  labelStyle: (theme, opacity) => ({
    color: theme.colors.picker.itemColor,
    fontSize: 16,
    flex: 1,
    marginLeft: 4,
    opacity,
  }),
  arrow: {
    flexDirection: 'row',
    justifyContent: 'center',
    alignItems: 'center',
    paddingVertical: 8,
    borderTopLeftRadius: 0,
    borderBottomLeftRadius: 0,
  },
  dropDown: theme => ({
    marginHorizontal: '3%',
    borderTopRightRadius: 5,
    borderTopLeftRadius: 5,
    borderBottomRightRadius: 5,
    borderBottomLeftRadius: 5,
    borderWidth: 1,
    borderColor: theme.colors.borderColorSeven,
  }),
  titleStyle: theme => ({
    position: 'absolute',
    top: -12,
    left: 4,
    zIndex: 1,
    backgroundColor: theme.colors.cardBackgroundColor,
    paddingHorizontal: 3,
    color: theme.colors.picker.itemColor,
  }),
});
